﻿import React from 'react';
import {connect} from 'react-redux';

import Feedback, { FeedbackSection } from '../Components/Feedback';

import {GuideFormBase, connectForm} from './GuideFormBase';
import Select from '../../../Forms/Components/Select';

import {required} from '../../../Forms/Validation/rules';

class Step4Form extends GuideFormBase {
    constructor(props) {
        super(props);
    }

    render() {
        const StepForm = this.stepFormWrapper;
        const NavigationButtons = this.navigationButtons;

        return (
            <StepForm heading="Familj">
            <label for="family" class="visually-hidden">Välj alternativ för familjesituation</label>
                <Select
                    id="family"
                    name="family"
                    validations={[required]}
                    data-validation-error-message="Välj ett alternativ i listan"
                    value={this.props.formData.family}
                >
                    <option value="">Välj</option>
                    <option value="single-household">Ensamhushåll</option>
                    <option value="family">Flera i hushållet</option>
                </Select>

                <NavigationButtons />

                <Feedback
                    condition={() => this.props.formData.family}
                >
                    <img src="https://www.lararforsakringar.se/globalassets/forsakringar/bilderillustrationer/illustrationer/soff-bord.svg" alt="" />
                    <FeedbackSection>
                        <h3>Återbetalningsskydd är ett skydd för dina närmaste</h3>
                        <p>
                            Återbetalningsskydd är en typ av efterlevandeskydd. Väljer du återbetalningsskydd får din familj
                            det samlade värdet av din pension om du mot förmodan går bort före din pensionering.
                        </p>
                        {this.props.formData.family === 'single-household' &&
                            <p>
                                Lever du ensam, eller om du inte har något försörjningsansvar, så kan du fundera på om du behöver ett återbetalningsskydd.
                                Om du valt bort skyddet så får du del av så kallad arvsvinst som kan innebära en högre pension. Observera dock att det
                                krävs en hälsodeklaration för att välja tillbaka återbetalningsskydd om din situation senare skulle ändras.
                            </p>
                        }
                    </FeedbackSection>
                </Feedback>

                <NavigationButtons mobileOnly={true} />
            </StepForm>
        );
    }
}

export default connectForm(Step4Form);
